export default __webpack_public_path__ + "static/media/plant.6053e95e.svg";